import React from 'react';
import { Box, Grid, Paper, Button, CircularProgress, Typography, Chip, Divider, Stack } from '@mui/material';
import { getRequest, postRequest, putRequest } from 'Includes/api/apicall';
import { GET_URL, POST_URL, PUT_URL } from 'Includes/urls';
import Form_Details from 'Containers/Company/static/company';
import Swal from 'sweetalert2'
import { dateFormat } from 'Includes/functions';
import ChatComponent from './Components/ChatComponent';
import { Dropdown } from 'Components/DropDown';
import  {  useState ,useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// import ChatbotWidget from 'Components/ChatbotWidget/ChatbotWidget';

function TicketDetails(props) {
    const location = useLocation();
    const { is_edit_form, ticket_id } = props;
    const [form_details, set_form_details] = React.useState(Form_Details[0]['page_details']['sub_sections'])
    const [loading, set_loading] = React.useState(true)
    const [fieldErrors, set_fieldErrors] = React.useState({})
    const [submitDisable, set_submitDisable] = React.useState(false)
    const [status_list, set_status_list] = React.useState([
        { id: 'open', name: 'Open' },
        { id: 'closed', name: 'Closed' },
        { id: 'resolved', name: 'Resolved' },
        { id: 'inprogress', name: 'In Progress' },
        { id: 'reopen', name: 'Reopen' },
        { id: 'ai_mode', name: 'AI Mode' },
    ])
    const [assignee_list, set_assignee_list] = React.useState([])
    const [ticketDetails, setTicketDetails] = React.useState({})
    const [chatList, set_chatList] = React.useState()
    const [nullFieldsAssigneeList, setNullFieldsAssigneeList] = useState([]);
    const [assignedTo, setAssignedTo] = useState(null); 
    const [selectedAssignee,setSelectedAssignee]=useState(null);

    // Resolve the logged-in user's ID so chat messages are aligned correctly
    const loggedInUserId = React.useMemo(() => {
        try {
            const userStr = localStorage.getItem('user');
            if (userStr) {
                const parsed = JSON.parse(userStr);
                return parsed.id ?? parsed.user_id ?? null;
            }
        } catch (_) {}
        return null;
    }, []);
    const ticketDropdownSx = {
        '& .MuiFormControl-root': {
            maxWidth: '100%',
            minWidth: '100%',
        },
        '& .MuiInputLabel-root': {
            color: '#667085',
            fontSize: '0.9rem',
            fontWeight: 500,
        },
        '& .MuiInput-root': {
            marginTop: '20px',
            backgroundColor: '#f9fbff',
            border: '1px solid #d8e1ef',
            borderRadius: '10px',
            paddingLeft: '12px',
            paddingRight: '8px',
        },
        '& .MuiInput-root:before, & .MuiInput-root:after': {
            display: 'none',
        },
        '& .MuiInput-root:hover:not(.Mui-disabled):before': {
            display: 'none',
        },
        '& .MuiSelect-select': {
            paddingTop: '12px',
            paddingBottom: '12px',
            fontSize: '0.95rem',
            color: '#1d2939',
        },
        '& .Mui-focused .MuiInputLabel-root, & .MuiInputLabel-root.Mui-focused': {
            color: '#1d4ed8',
        },
        '& .Mui-focused .MuiInput-root': {
            borderColor: '#1d4ed8',
            boxShadow: '0 0 0 3px rgba(29, 78, 216, 0.12)',
        },
    };

    const ticketMeta = [
        { label: 'Ticket Number', value: ticketDetails.id || '-' },
        { label: 'Created On', value: ticketDetails.created || '-' },
        { label: 'User Name', value: ticketDetails.username || '-' },
        { label: 'Mobile Number', value: ticketDetails.mobile_num || '-' },
        { label: 'Company Name', value: ticketDetails.company_name || '-' },
    ];

    const getStatusColor = (status = '') => {
        switch (status.toLowerCase()) {
            case 'open':
                return 'success';
            case 'closed':
                return 'default';
            case 'resolved':
                return 'info';
            case 'inprogress':
                return 'warning';
            case 'reopen':
                return 'secondary';
            default:
                return 'default';
        }
    };

    useEffect(() => {
        // Load users first so nullFieldsAssigneeList is ready before the
        // ticket details (and coordinator auto-selection) happen
        getUserListWithNullFields().then(() => {
            getUserList();
        });
    }, [])

    useEffect(() => {
        localStorage.setItem("lastVisitedURL", location.pathname);
    }, [location.pathname]);

    const getUserList = () => {
        const url = GET_URL.user.api
        const params = {}
        getRequest(url, params, props).then(response => {
            if (response && response.status === 200) {
                set_assignee_list(() => response.data.dta)
            }
            getTicketDetails(ticket_id);
        })
    }

    const getTicketDetails = (id) => {
        const url = GET_URL.ticket.api + id + '/';
        const params = {};
        getRequest(url, params, props).then(response => {
            if (response && response.status === 200) {
                let submissions = response.data.message_ticket;
                let userMapping = {};
                submissions.forEach((doc) => {
                    // Fallback to check message content if the backend boolean isn't set correctly on older messages
                    const botStrings = [
                        "Our support team will assist you shortly",
                        "Edubricz Support Bot",
                        "Edubricz Support Assistant",
                        "Welcome to Edubricz Support",
                        "Welcome to Edubricz.",
                        "To reset your password",
                        "To reset a user's password",
                        "To add a sibling or another student",
                        "To link siblings or add a student"
                    ];
                    const isBotReply = doc.is_bot_reply || (doc.data && botStrings.some(s => doc.data.includes(s)));
                    
                    if (isBotReply) {
                        doc.sender = loggedInUserId;
                        doc.name = "Edubricz Support Bot";
                    } else {
                        doc.sender = doc.responder_user_id ? doc.responder_user_id : doc.user_id;
                        doc.name = doc.user;
                    }
                    doc.message = doc.data;
                    doc.id = doc.user_id;
                    userMapping[doc.id] = { name: doc.name, avatar: doc.senderAvatar };
                    if (doc.document) {
                        doc.message = (
                            <div style={{ height: "40px", opacity: 0.7 }}>{doc.comment}</div>
                        );
                    }
                });
    
                let ticketDetailsTemp = {
                    id: response.data.id,
                    ticket_status: response.data.ticket_status === 'ai_mode' ? 'open' : response.data.ticket_status,
                    user_id: response.data.user,
                    username: response.data.username,
                    ticket_assigned_to_id: response.data.ticket_assigned_to,
                    ticket_assigned_to_username: "",
                    created: dateFormat(response.data.created, 'DD-MM-YYYY hh:mm A'),
                    mobile_num: response.data.mobile_num,
                    company_name: response.data.company_name,
                };

                const existingAssignee = response.data.ticket_assigned_to;
                // company_id and coordinator_id are now returned directly by the
                // TicketSerializer (backend was updated to expose these fields)
                const coordinatorId =
                    response.data.coordinator_id ||
                    response.data.company_coordinator_id ||
                    null;
                const ticketId = response.data.id;

                if (existingAssignee) {
                    // Ticket already has an assignee — honour it
                    setAssignedTo(existingAssignee);
                    setSelectedAssignee(existingAssignee);
                } else if (coordinatorId) {
                    // No assignee yet — auto-select the company's coordinator
                    setSelectedAssignee(coordinatorId);
                    setAssignedTo(coordinatorId);
                    // Set ticket_assigned_to_id so the "Reassign To" dropdown branch
                    // renders and displays the pre-selected coordinator
                    ticketDetailsTemp.ticket_assigned_to_id = coordinatorId;
                    autoAssignCoordinator(ticketId, coordinatorId);
                }

                set_chatList(() => [...submissions]);
                setTicketDetails(() => ticketDetailsTemp);
                set_loading(() => false);

                getRequest(GET_URL.user.api, {}, props).then(userResponse => {

                    if (userResponse && userResponse.status === 200) {
                        const users = userResponse.data.data || userResponse.data;
                        const assignedUser = users.find(user => user.id === response.data.ticket_assigned_to);
    
                        if (assignedUser) {
                            ticketDetailsTemp.ticket_assigned_to_username = assignedUser.username;
                        } else {
                            ticketDetailsTemp.ticket_assigned_to_username = "Unassigned";
                        }
    
                        setTicketDetails(prev => ({
                            ...prev,
                            ticket_assigned_to_username: ticketDetailsTemp.ticket_assigned_to_username
                        }));
                    }
                });
            }
        });
    };
    
    const uploadRemarks = (newDoc) => {
        if (!newDoc.comment.trim() && !newDoc.document) {
            return;
        }
        const payload = new FormData();
        if (newDoc.document && Object.keys(newDoc.document).length !== 0) {
            payload.append('image', newDoc.document);
        }
        payload.append('data', newDoc.comment.trim());
        payload.append('ticket_id', ticket_id);
    
        let url = POST_URL.ticket.api;
        postRequest(url, payload, props).then((response) => {
            if (response && response.status === 200) {
                getTicketDetails(ticket_id);
            }
        });
    };
    
    const handleDropdownChange = (e, name) => {
        let { value } = e.target
        let ticketDetailsTemp = { ...ticketDetails }
        ticketDetailsTemp[name] = value
        setTicketDetails(() => ticketDetailsTemp)
    }

    const getUserListWithNullFields = () => {
        const url = GET_URL.user.api;
        const params = {
            company_id: null,
        };
        // Return the promise so callers can chain after users are loaded
        return getRequest(url, params, {})
            .then((response) => {
                if (response && response.status === 200) {
                    setNullFieldsAssigneeList(response.data.data || response.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching names:", error);
            });
    };
    
    // Silently saves the coordinator as the ticket assignee (no popup, no spinner)
    const autoAssignCoordinator = (ticketId, coordinatorId) => {
        const url = PUT_URL.ticket.api + ticketId + '/';
        const payload = {
            ticket_assigned_to: coordinatorId,
            is_external: false,
        };
        putRequest(url, payload, {}).catch(() => {});
    };

    const submit = () => {
        set_submitDisable(true);
        let post_data = {
            "ticket_status": ticketDetails.ticket_status,
            "is_external": false,
            "ticket_assigned_to": selectedAssignee || 1 
        };
    
        const url = PUT_URL.ticket.api + ticketDetails.id + '/';
    
        putRequest(url, post_data, {})
            .then(response => {
                if (response && response.status === 200) {
                    setTicketDetails(prev => ({
                        ...prev,
                        ticket_status: ticketDetails.ticket_status,
                        ticket_assigned_to_id: selectedAssignee || 1, 
                        ticket_assigned_to_username: nullFieldsAssigneeList.find(user => user.id === (selectedAssignee || 1))?.username || "admin"
                    }));
    
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: "Update Successful",
                        text: "Ticket status has been successfully updated.",
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            })
            .finally(() => {
                set_submitDisable(false);
            });
    }; 
    return (
        <>
            {loading && (
                <Box display='flex' justifyContent='center' alignItems='center' minHeight='220px'>
                    <CircularProgress />
                </Box>
            )}
            {!loading &&
                <>
                    <Paper
                        className='padding-20'
                        sx={{
                            borderRadius: 3,
                            border: '1px solid #e6ebf4',
                            boxShadow: '0 10px 30px rgba(16, 24, 40, 0.06)',
                            background: 'linear-gradient(180deg, #ffffff 0%, #fafcff 100%)',
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item md={4} xs={12} className='fs-18 p-10'>
                                <Box
                                    sx={{
                                        borderRadius: 2,
                                        border: '1px solid #dce6f5',
                                        overflow: 'hidden',
                                        backgroundColor: '#ffffff',
                                    }}
                                >
                                    <Stack
                                        direction='row'
                                        alignItems='center'
                                        justifyContent='space-between'
                                        sx={{
                                            px: 2,
                                            py: 1.5,
                                            background: 'linear-gradient(90deg, #f4f8ff 0%, #eef5ff 100%)',
                                            borderBottom: '1px solid #dce6f5',
                                        }}
                                    >
                                        <Typography variant='h6' fontWeight={700}>
                                            Ticket Details
                                        </Typography>
                                        <Chip
                                            size='small'
                                            label={(ticketDetails.ticket_status || 'unknown').toUpperCase()}
                                            color={getStatusColor(ticketDetails.ticket_status)}
                                            sx={{ fontWeight: 700, letterSpacing: 0.4 }}
                                        />
                                    </Stack>
                                    <Box sx={{ p: 2 }}>
                                    {ticketMeta.map((item, idx) => (
                                        <Box key={item.label}>
                                            <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={2} sx={{ py: 1.25 }}>
                                                <Typography variant='body2' color='text.secondary'>
                                                    {item.label}
                                                </Typography>
                                                <Typography variant='body1' fontWeight={500} textAlign='right'>
                                                    {item.value}
                                                </Typography>
                                            </Stack>
                                            {idx < ticketMeta.length - 1 && <Divider />}
                                        </Box>
                                    ))}
                                    </Box>
                                </Box>

                                <Box
                                    sx={{
                                        mt: 3,
                                        borderRadius: 2,
                                        border: '1px solid #e7e9ef',
                                        backgroundColor: '#ffffff',
                                        p: 2,
                                    }}
                                >
                                    <Typography variant='subtitle1' fontWeight={600}>
                                        Update Ticket
                                    </Typography>
                                    <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
                                        Change status and assignment from one place.
                                    </Typography>

                                    <Box className='fs-18 mv-20 '>
                                        <Typography variant='subtitle2' color='text.secondary' sx={{ mb: 1 }}>
                                            Update Status
                                        </Typography>
                                        <Box sx={ticketDropdownSx}>
                                            <Dropdown
                                                data={status_list}
                                                name={'ticket_status'}
                                                value={ticketDetails.ticket_status}
                                                onChange={(e) => handleDropdownChange(e, 'ticket_status')}
                                                error={fieldErrors['ticket_status']}
                                                label={'Status'}
                                                hideSelect={true}
                                                variant='standard'
                                            />
                                        </Box>
                                    </Box>

                                    <Box className='fs-18 mv-20 ' sx={{ mt: 3 }}>
                                        <Typography variant='subtitle2' color='text.secondary' sx={{ mb: 1 }}>
                                            Assignment
                                        </Typography>
                                        {ticketDetails.ticket_assigned_to_id ? (
                                            <>
                                                <Typography variant="body2" gutterBottom color='text.secondary'>
                                                    Assigned to: {ticketDetails.ticket_assigned_to_username || 'Unassigned'}
                                                </Typography>
                                                <Box sx={ticketDropdownSx}>
                                                    <Dropdown
                                                        data={nullFieldsAssigneeList.map((user) => ({
                                                            id: user.id,
                                                            name: `${user.username}`,
                                                        }))}
                                                        name="assignee"
                                                        value={selectedAssignee}
                                                        onChange={(e) => setSelectedAssignee(e.target.value)}
                                                        error={fieldErrors['assignee']}
                                                        label="Reassign To"
                                                        hideSelect={true}
                                                        variant="standard"
                                                    />
                                                </Box>
                                            </>
                                        ) : (
                                            <Box sx={ticketDropdownSx}>
                                                <Dropdown
                                                    data={nullFieldsAssigneeList.map((user) => ({
                                                        id: user.id,
                                                        name: `${user.username}`,
                                                    }))}
                                                    name="assignee"
                                                    value={selectedAssignee}
                                                    onChange={(e) => setSelectedAssignee(e.target.value)}
                                                    error={fieldErrors['assignee']}
                                                    label="Assign To"
                                                    hideSelect={true}
                                                    variant="standard"
                                                />
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                                <Box display='flex' className='mv-20' sx={{ mt: 2 }}>
                                    <Button variant='contained'
                                        color='primary' className='submit'
                                        disabled={submitDisable}
                                        onClick={submit}
                                        sx={{ px: 3, py: 1, borderRadius: 2, fontWeight: 700, textTransform: 'none' }}>
                                        Update
                                    </Button>
                                </Box>
                                </Grid>
                                    <Grid item md={8} xs={12} sx={{ borderLeft: { md: '1px solid #edf0f6' }, pl: { md: 2 } }}>
                                        <Box
                                            sx={{
                                                borderRadius: 2,
                                                border: '1px solid #e8edf6',
                                                overflow: 'hidden',
                                                backgroundColor: '#f8fbff',
                                            }}
                                        >
                                        <ChatComponent
                                            data={chatList}
                                            users={[{ name: loggedInUserId, avatar: null }]}
                                            isUserTeacher={true}
                                            uploadRemarks={uploadRemarks}
                                        />
                                        </Box>
                                    </Grid>
                                </Grid>
                    </Paper>
                </>
               }
        </>
    )

}

export default TicketDetails;
